import pramodaya from "../assets/pramodaya.jpg";
import smgschools from "../assets/smg.jpg";
import tigi from "../assets/tigi.jpg";

import { BsArrowUpRight } from "react-icons/bs";

function Portfolio() {
  const projects = [
    {
      title: "Pramodaya",
      website: "https://pramodaya.in",
      industry: "Business Consulting",
      image: pramodaya,
      description:
        "Modern business website focused on credibility, lead generation and user experience.",
    },

    {
      title: "SMG Schools",
      website: "https://smgschools.co.in",
      industry: "Education",
      image: smgschools,
      description:
        "Responsive educational platform designed for students, parents and school administration.",
    },

    {
      title: "TIGI Industries",
      website: "https://tigiindustries.in",
      industry: "Manufacturing",
      image: tigi,
      description:
        "Industrial website showcasing products, capabilities and company expertise.",
    },
  ];

  return (
    <section id="portfolio" className="portfolio-section">
      <div className="container">
        <div className="section-title">
          <span className="section-subtitle">PORTFOLIO</span>

          <h2>Projects We've Built</h2>

          <p>Real businesses. Real websites. Real results.</p>
        </div>

        <div className="row g-4">
          {projects.map((project, index) => (
            <div className="col-lg-4" key={index}>
              <a
                href={project.website}
                target="_blank"
                rel="noopener noreferrer"
                className="portfolio-link"
              >
                <div className="portfolio-card">
                  <div className="portfolio-image">
                    <img src={project.image} alt={project.title} />
                  </div>

                  <div className="portfolio-content">
                    <span className="project-industry">{project.industry}</span>

                    <h3>{project.title}</h3>

                    <p>{project.description}</p>

                    <div className="visit-project">
                      Visit Website
                      <BsArrowUpRight />
                    </div>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
